module.exports = __webpack_public_path__ + "fa-brands-400.cafa7a5ee0a9964b4839.svg";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.svg
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.svg
// module chunks = styles